import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm from '../components/forms/ContactForm';
import { Breadcrumbs } from '../components/Breadcrumbs';

const Ktpn100Page: React.FC = () => {
  const pageTitle = 'КТПН 100 кВА — надёжная подстанция для малого бизнеса и стройплощадок';
  const pageDescription =
    'Узнайте все о КТПН 100 кВА: технические характеристики, преимущества, сферы применения и стоимость. Готовые решения от производителя с доставкой по России.';
  const imageUrl = '/images/ktp/ktpn.jpg';

  return (
    <>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href="https://prominnovations.ru/ktpn-100" />
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:image" content={`https://prominnovations.ru${imageUrl}`} />
        <meta property="og:url" content="https://prominnovations.ru/ktpn-100" />
        <meta property="og:type" content="article" />
      </Helmet>
      <div className="bg-[#f9fcff] font-museo-sans">
        <div className="container-custom mx-auto pt-2 lg:pt-5">
          <Breadcrumbs />
        </div>
        <div className="container-custom mx-auto pb-5 lg:pb-10 text-[#313131]">
          <div className="bg-white rounded-3xl p-5 lg:p-10 shadow-lg">
            <h1 className="text-3xl lg:text-4xl font-bold mb-4">
              КТПН 100 кВА: надёжная подстанция для малого бизнеса и стройплощадок
            </h1>
            <img
              src="/images/ktp/ktpn.jpg"
              alt="КТПН 100 кВА"
              className="w-full h-auto rounded-lg my-5 object-cover max-h-[500px]"
            />
            <p className="text-lg mb-4">
              Комплектная трансформаторная подстанция на 100 кВА — это универсальное и
              востребованное решение для электроснабжения небольших объектов. Она сочетает в себе
              компактность, надёжность и простоту монтажа. В этой статье мы подробно разберём, что
              такое КТПН 100 кВА, где она применяется, из чего состоит и сколько стоит.
            </p>
            <h2 className="text-2xl lg:text-3xl font-bold mt-6 mb-4">Что такое КТПН 100 кВА?</h2>
            <div className="bg-blue-50 border-l-4 border-blue-500 text-blue-800 p-4 rounded-r-lg my-4">
              <p>
                <strong>КТПН 100 кВА</strong> — это комплектная трансформаторная подстанция наружной
                установки (Н) киоскового типа (К), предназначенная для приёма, преобразования и
                распределения электроэнергии трёхфазного переменного тока частотой 50 Гц. Она
                понижает высокое напряжение (6 или 10 кВ) до потребительского уровня 0,4 кВ.
              </p>
            </div>
            <h2 className="text-2xl lg:text-3xl font-bold mt-6 mb-4">Технические характеристики</h2>
            <div className="overflow-x-auto rounded-lg border border-gray-200 shadow-sm">
              <table className="min-w-full divide-y-2 divide-gray-200 bg-white text-sm">
                <thead className="text-left">
                  <tr>
                    <th className="whitespace-nowrap px-4 py-2 font-semibold text-gray-900">
                      Параметр
                    </th>
                    <th className="whitespace-nowrap px-4 py-2 font-semibold text-gray-900">
                      Значение
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Номинальная мощность
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">100 кВА</td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Высшее напряжение (ВН)
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">6 кВ, 10 кВ</td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Низшее напряжение (НН)
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">0,4 кВ</td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Схема и группа соединения обмоток
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">У/Ун-0, Д/Ун-11</td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Тип исполнения
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">
                      Киосковая, тупиковая/проходная
                    </td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Габариты (ДхШхВ), мм
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">~2500х2500х2500</td>
                  </tr>
                  <tr className="odd:bg-gray-50">
                    <td className="whitespace-nowrap px-4 py-2 font-medium text-gray-900">
                      Масса, кг
                    </td>
                    <td className="whitespace-nowrap px-4 py-2 text-gray-700">~1500</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <h2 className="text-2xl lg:text-3xl font-bold mt-6 mb-4">Сферы применения</h2>
            <p>
              Благодаря своей универсальности, КТПН 100 кВА находит применение в самых разных
              отраслях:
            </p>
            <ul className="list-disc list-inside space-y-2 my-4">
              <li>
                <strong>Строительные площадки:</strong> для временного электроснабжения бытовок,
                инструмента и оборудования.
              </li>
              <li>
                <strong>Малые производственные предприятия:</strong> цеха, мастерские, СТО.
              </li>
              <li>
                <strong>Сельское хозяйство:</strong> фермы, теплицы, насосные станции.
              </li>
              <li>
                <strong>Объекты инфраструктуры:</strong> небольшие торговые павильоны, АЗС, базовые
                станции сотовой связи.
              </li>
              <li>
                <strong>Частные домовладения:</strong> коттеджные посёлки, СНТ.
              </li>
            </ul>
            <h2 className="text-2xl lg:text-3xl font-bold mt-6 mb-4">Преимущества и недостатки</h2>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                <h3 className="font-bold text-lg text-green-800 mb-2">Преимущества:</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>
                    <span className="font-semibold">Полная заводская готовность:</span> минимизирует
                    время и затраты на монтаж.
                  </li>
                  <li>
                    <span className="font-semibold">Компактность:</span> не требует много места для
                    установки.
                  </li>
                  <li>
                    <span className="font-semibold">Надёжность:</span> проверенные комплектующие и
                    заводская сборка.
                  </li>
                  <li>
                    <span className="font-semibold">Безопасность:</span> корпус защищает от
                    случайного прикосновения и атмосферных осадков.
                  </li>
                  <li>
                    <span className="font-semibold">Универсальность:</span> подходит для разных
                    климатических зон.
                  </li>
                </ul>
              </div>
              <div className="bg-red-50 p-4 rounded-lg border border-red-200">
                <h3 className="font-bold text-lg text-red-800 mb-2">Недостатки:</h3>
                <ul className="list-disc list-inside space-y-1">
                  <li>
                    <span className="font-semibold">Ограниченная мощность:</span> 100 кВА может быть
                    недостаточно для растущих потребностей.
                  </li>
                  <li>
                    <span className="font-semibold">Требуется площадка:</span> необходима
                    подготовленная ровная площадка для установки.
                  </li>
                </ul>
              </div>
            </div>
            <h2 className="text-2xl lg:text-3xl font-bold mt-6 mb-4">
              Из чего состоит и сколько стоит?
            </h2>
            <p>
              Стандартная комплектация КТПН 100 кВА включает силовой трансформатор (чаще всего
              масляный ТМГ), устройство высокого напряжения (УВН) и распределительное устройство
              низкого напряжения (РУНН). Всё это смонтировано в прочном металлическом корпусе
              (киоске).
            </p>
            <div
              className="bg-gray-100 border-t-4 border-blog-accent rounded-b text-gray-800 px-4 py-3 shadow-md my-6"
              role="alert"
            >
              <div className="flex">
                <div className="py-1">
                  <svg
                    className="fill-current h-6 w-6 text-blog-accent mr-4"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                  >
                    <path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" />
                  </svg>
                </div>
                <div>
                  <p className="font-bold">Стоимость КТПН 100 кВА зависит от комплектации.</p>
                  <p className="text-sm">
                    Цена формируется исходя из типа и марки силового трансформатора, используемых
                    автоматических выключателей, наличия АВР и других опций. Чтобы получить точный и
                    быстрый расчёт, оставьте заявку — мы подготовим предложение за 30 минут.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-custom mx-auto pb-5 lg:pb-10">
          <ContactForm />
        </div>
      </div>
    </>
  );
};

export default Ktpn100Page;
